import { render, staticRenderFns } from "./manual-item-selection-option.vue?vue&type=template&id=20c0e1dc&"
import script from "./manual-item-selection-option.vue?vue&type=script&lang=js&"
export * from "./manual-item-selection-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports